module.exports = __webpack_public_path__ + "assets/img/1688_2.0e97dbfc.png";